<template>
  <div class="m-5 md:m-15 2xl:m-20">
    <!-- Popup message alert if save is not possible (Evaluation in progress on this template) -->
    <EvalInProgress
      :evaluation-in-progress="evaluationInProgress"
      @massAssignation="displayAssignTemplate()"
      @showPreview="showPreview = true"
    />
    <!-- END Popup message alert -->

    <mass-template-assignation
      :opened="massAssignation"
      @close="massAssignation = false"
      :template="massAssignationTemplate"
    />

    <!-- BEGIN Popup confirm delete template -->
    <popup
      :opened="confirmDeleteTemplate > -1"
      @close="confirmDeleteTemplate = -1"
    >
      <!-- Screen to ask a confirmation to close current evaluation -->
      <div v-if="confirmDeleteTemplate == 0">
        <div class="my-5 xl:my-15">
          <h3 class="mb-5 md:mb-10 2xl:mb-15">
            Supprimer le modèle de page "{{ templateNameToDelete }}"
          </h3>

          <div class="mb-10">
            <p class="text-indigo-600 text-lg text-center">
              Êtes-vous sûr de vouloir supprimer la page "{{
                templateNameToDelete
              }}" ?
            </p>
            <p class="text-indigo-600 text-lg text-center">
              Cette suppression sera définitive et irrévocable.
            </p>
          </div>

          <div class="flex justify-center bg-pink">
            <action-button
              class="mr-4"
              border-color="border-pink-600"
              text-color="text-pink-600"
              bg-color="bg-pink-300"
              libelle="ANNULER"
              @clickAction="confirmDeleteTemplate = -1"
            />
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-pink-600"
              libelle="SUPPRIMER"
              type-shadow="shadow-pink"
              @clickAction="confirm_delete_template"
            />
          </div>
        </div>
      </div>
      <!-- END Screen to ask a confirmation to close current evaluation -->

      <!-- Screen to confirm the close -->
      <div v-if="confirmDeleteTemplate == 1">
        <h3 class="w-full text-indigo-600 mt-12 mb-10">
          Le modèle de page "{{ templateNameToDelete }}"<br>a bien été
          supprimé !
        </h3>
        <illustration
          name="basket"
          class="w-full m-5"
        />
      </div>
      <!-- END Screen to confirm the close -->

      <!-- If template to delete is assigned on at least 1 beneficiary -->
      <div v-if="confirmDeleteTemplate == 2">
        <div class="my-5 xl:my-15">
          <h3 class="mb-5 md:mb-10 2xl:mb-15">
            Supprimer le modèle de page "{{ templateNameToDelete }}"
          </h3>

          <div class="mb-5">
            <p class="text-indigo-600 text-lg text-center">
              Êtes-vous sûr de vouloir supprimer le modèle de page "{{
                templateNameToDelete
              }}" ?
            </p>
            <p class="text-indigo-600 text-lg text-center">
              Cette suppression sera définitive et irrévocable.
            </p>
          </div>

          <div class="mb-10">
            <p class="text-pink-600 text-lg text-center">
              Attention, ce modèle de page est utilisé par
              {{ listAssignedUsersTemplate.length }} bénéficiaire<span
                v-if="listAssignedUsersTemplate.length > 1"
              >s</span>
              :
            </p>
            <p class="text-pink-600 text-lg text-center">
              <span
                v-for="(beneficiary, index) in listAssignedUsersTemplate"
                :key="beneficiary.id"
              >
                <span v-if="index > 0">-&nbsp;</span>{{ beneficiary.firstname }}
                <span class="uppercase">{{ beneficiary.lastname }}</span>
              </span>
            </p>
            <p class="text-pink-600 text-lg text-center">
              En cas de suppression, le modèle de page "{{
                templatePageToAssignAfterDelete.name
              }}" leur sera attribué.
            </p>
          </div>

          <div class="flex justify-center bg-pink">
            <action-button
              class="mr-4"
              border-color="border-pink-600"
              text-color="text-pink-600"
              bg-color="bg-pink-300"
              libelle="ANNULER"
              @clickAction="confirmDeleteTemplate = -1"
            />
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-pink-600"
              libelle="SUPPRIMER"
              type-shadow="shadow-pink"
              @clickAction="
                confirm_delete_template(templatePageToAssignAfterDelete)
              "
            />
          </div>
        </div>
      </div>
      <!-- END If template to delete is assigned on at least 1 beneficiary -->
    </popup>
    <!-- END Popup confirm delete template -->

    <!-- BEGIN Popup confirm deactivate template -->
    <deactivate-template-popup
      :confirm-deactivate-template="confirmDeactivateTemplate"
      :template-name-to-deactivate="templateNameToDeactivate"
      :list-assigned-users-template="listAssignedUsersTemplate"
      :template-page-to-assign-after-delete="templatePageToAssignAfterDelete"
      @confirm_deactivate_template="
        (templatePageToAssignAfterDelete) => {
          confirm_deactivate_template(templatePageToAssignAfterDelete);
        }
      "
      @close="confirmDeactivateTemplate = -1"
    />
    <!-- END Popup confirm deactivate template -->

    <!-- BEGIN Popup confirm activate template -->
    <activate-template-popup
      :confirm-activate-template="confirmActivateTemplate"
      :template-name-to-deactivate="templateNameToDeactivate"
      @confirm_activate_template="confirm_activate_template()"
      @close="confirmActivateTemplate = -1"
    />
    <!-- END Popup confirm activate template -->

    <!-- Popup modal preview -->
    <popup
      :opened="showPreview"
      @close="showPreview = false"
    >
      <div>
        <h3 class="mt-10 mb-10 w-full">
          {{ infosPage.libelle_template }}
        </h3>
        <!-- Content modal -->

        <list-grid
          grid="grid-cols-11"
          :list-items="template[1].criterions"
        >
          <template #header>
            <div class="ml-2 md:ml-10 col-span-4">
              Intitulé
            </div>
            <div class="col-span-2 hidden md:inline">
              Auto-évaluation
            </div>
            <div class="col-span-2 hidden md:inline">
              Dernière éval.ref
            </div>
            <div class="col-span-2 hidden md:inline">
              Nouvelle éval.ref
            </div>
            <div class="col-span-5 md:hidden">
              Evaluations
            </div>
            <div class="col-span-1 text-center">
              Comm.
            </div>
          </template>
          <template #accordionDescription="{ num, item }">
            <div class="row-start-1 row-span-3 md:row-span-1 col-span-4 text-sm ml-2 md:ml-10">
              {{ item.description }}
            </div>

            <input-select
              class="col-start-5 col-span-4 row-start-1 md:row-start-auto md:col-span-2"
              libelle="Auto-évaluation"
              :name="num + 'auto_eval'"
              :value="
                template[0].criterions[
                  Math.floor(
                    Math.random() * Math.floor(template[0].criterions.length)
                  )
                ].value
              "
              :datas="template[0].criterions"
            />

            <input-text
              class="col-start-5 col-span-4 row-start-2 md:row-start-auto md:col-span-2"
              libelle="Dernière éval.ref"
              :name="num + 'derniere_eval'"
              :disabled="true"
              :value="
                template[0].criterions[
                  Math.floor(
                    Math.random() * Math.floor(template[0].criterions.length)
                  )
                ].value
              "
            />

            <input-select
              class="col-start-5 col-span-4 row-start-3 md:row-start-auto md:col-span-2"
              libelle="Nouvelle éval.ref"
              :name="num + 'nouvelle_eval'"
              :necessary="true"
              :value="
                template[0].criterions[
                  Math.floor(
                    Math.random() * Math.floor(template[0].criterions.length)
                  )
                ].value
              "
              :datas="template[0].criterions"
            />

            <icon-comment class="col-span-1 row-start-2 md:row-start-auto place-self-center" />
          </template>
        </list-grid>

        <input-text-area
          v-if="template[2] && template[2].isDisplayed"
          class="px-10 mt-10"
          name="comment"
          libelle="Commentaire général"
          value="Exemple de commentaire"
        />
        <!-- END Content modal -->
      </div>
    </popup>
    <!-- END Popup modal preview -->
    <div v-if="isEditable">
      <!-- Title -->
      <div class="flex justify-center">
        <input-title
          class="mb-5 md:mb-15 2xl:mb-20 w-3/4"
          name="title"
          :value="infosPage.libelle_template"
          :disabled="
            !$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER) ||
              this.evaluationInProgress
          "
          :error="true"
          :maxlength="40"
          @input="
            (value) => {
              infosPage.libelle_template = value;
            }
          "
          @valid="
            (title) => {
              SET_NAME_TEMPLATE_IN_LIST([infosPage.id_template, title]);
            }
          "
        />
      </div>
      <!-- END Title -->

      <!-- BEGIN Bloc action buttons -->
      <list-buttons
        :evaluation-in-progress="evaluationInProgress"
        :is-active="infosPage.is_active"
        @preview="
          () => {
            showPreview = true;
          }
        "
        @deactivateTemplate="displayConfirmDeactivateTemplate()"
        @activateTemplate="displayConfirmActivateTemplate()"
        @confirmDelete="
          () => {
            displayConfirmDeleteTemplate();
          }
        "
        @assignTemplate="displayAssignTemplate()
        "
        can-delete
      />
      <!-- END Bloc action buttons -->

      <div class="flex flex-col">
        <div class="text-base mb-5 uppercase">
          {{ template[0].libelle }}
        </div>
        <div
          class="grid grid-cols-12 gap-x-4 gap-y-10 place-content-center mb-15"
        >
          <!-- <transition-group enter-active-class="ease-in duration-1000" enter-class="bg-indigo-300 border-0 rounded-xl" enter-to-class="bg-none border-0 rounded-xl" tag="div"> -->
          <div
            class="relative col-span-full lg:col-span-3"
            v-for="(criteria, i) in template[0].criterions"
            :key="i"
          >
            <input-text
              name="comprehension_orale_derniere_eval"
              libelle=""
              :value="criteria.value"
              @input="
                (newValue) => {
                  $set(criteria, 'value', newValue);
                }
              "
              :disabled="!$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
            />

            <div
              v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
              class="absolute flex cursor-pointer bottom-8/12 left-11/12 p-2 2xl:p-2.5 items-center text-pink-600 bg-pink-100 border border-pink-600 border-opacity-25 rounded-full"
              @click="deleteCriterion(0, i)"
            >
              <icon
                name="close"
                class="h-2 w-2 2xl:h-2.5 2xl:w-2.5"
              />
            </div>
          </div>
          <!-- </transition-group> -->
          <!-- BEGIN Button to add a criterion -->
          <div
            v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
            class="col-start-1 col-span-full w-max-content w-max cursor-pointer flex hover:font-medium"
            @click="addCriterion(0)"
          >
            <span class="plus-button 2xl:h-10 2xl:w-10">
              <icon name="plus" />
            </span>
            <span class="text-base text-gray-600 ml-3 mt-1.5 flex-initial">
              Ajouter un critère
            </span>
          </div>
          <!-- END Button to add a criterion -->
        </div>

        <div
          id="title1"
          class="text-base mb-8 uppercase"
        >
          {{ template[1].libelle }}
        </div>

        <div class="mb-15">
          <draggable
            v-if="template.length > 0"
            v-model="template[1].criterions"
            v-bind="dragOptions"
            @start="drag = true"
            @end="drag = false"
            :style="{
              'cursor:grab;': $can(constants.PERMISSION_MODELE_DE_PAGE_EDITER),
            }"
          >
            <transition-group
              enter-active-class="ease-in duration-1000"
              enter-class="bg-indigo-300 border-0 rounded-xl"
              enter-to-class="bg-none border-0 rounded-xl"
              leave-active-class="linear duration-1000"
              leave-class="h-20 opacity-100"
              leave-to-class="h-0 opacity-0"
              tag="div"
            >
              <div
                class="bg-white h-16 lg:h-24 2xl:h-32 w-full border rounded-lg shadow-md shadow-gray-600 mb-5 grid grid-cols-12 items-center"
                v-for="(criteria, j) in template[1].criterions"
                :key="criteria.location"
                :id="'intitule' + j"
                :style="displayValider === -1 ? 'cursor:grab' : ''"
              >
                <!-- BEGIN Libelle -->
                <div class="col-span-1 justify-self-center">
                  <icon
                    name="move"
                    class="text-indigo-600 w-5 h-5"
                  />
                </div>
                <div class="col-span-3 md:col-span-2 ml-2 md:ml-0">
                  <input-text
                    v-if="displayValider === j"
                    name="libelle"
                    libelle=""
                    :value="criteria.libelle"
                    @input="
                      (newValue) => {
                        $set(criteria, 'libelle', newValue);
                      }
                    "
                  />
                  <p
                    v-else
                    class="overflow-hidden max-h-15 description text-base text-left"
                  >
                    {{ criteria.libelle }}
                  </p>
                </div>
                <!-- END Libelle -->

                <div
                  class="col-span-1 justify-self-center border-solid border-r-2 border-indigo-500 h-4/6"
                />

                <!-- BEGIN Description détaillé -->
                <div
                  class="col-span-6 md:col-span-7 relative font-normal flex justify-between items-center"
                >
                  <input-text-area
                    v-if="displayValider === j"
                    name="description"
                    libelle=""
                    :value="criteria.description"
                    @input="
                      (newValue) => {
                        $set(criteria, 'description', newValue);
                      }
                    "
                  />

                  <p
                    v-else
                    class="overflow-hidden max-h-15 description text-base font-light"
                  >
                    {{ criteria.description }}
                  </p>

                  <span
                    v-show="displayValider === j"
                    @click.prevent="validEdit"
                    class="cursor-pointer text-teal-400 ml-5"
                  >
                    <icon
                      name="checkmark-circle"
                      class="text-teal-600"
                    />
                  </span>
                </div>
                <!-- END Description détaillé -->

                <!-- BEGIN Bouton Menu déroulant (modifier, dupliquer, supprimer)  -->
                <span class="col-span-1 justify-self-start">
                  <span
                    v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
                    class="cursor-pointer"
                    @click="displayDropdownMenu(j)"
                    @click.stop
                  >
                    <div class="p-3">
                      <icon
                        name="more-vertical"
                        class="text-pink-600"
                      />
                    </div>
                  </span>
                </span>
                <div
                  class="z-20 absolute dropdown-menu mt-28 right-15 w-max-content w-max ml-auto rounded-md bg-white shadow-md shadow-gray-600 text-sm"
                  v-show="dropDownMenu === j"
                  v-click-outside="forceHide"
                >
                  <div class="mx-5 my-3 text-left">
                    <div class="flex flex-col">
                      <div
                        class="flex cursor-pointer pt-1 text-gray-600 hover:text-gray-900"
                      >
                        <button @click="editCriterion(j)">
                          Modifier
                        </button>
                      </div>
                      <div
                        class="flex cursor-pointer pt-1 text-gray-600 hover:text-gray-900"
                      >
                        <button @click="cloneCriterion(1, j)">
                          Dupliquer
                        </button>
                      </div>
                      <div
                        class="flex cursor-pointer pt-1 text-gray-600 hover:text-gray-900"
                      >
                        <button @click="deleteCriterion(1, j)">
                          Supprimer
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END Bouton Menu déroulant (modifier, dupliquer, supprimer)  -->
              </div>
            </transition-group>
          </draggable>
          <!-- BEGIN Button to add a intitulé -->
          <div
            v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
            class="w-max-content w-max cursor-pointer flex hover:font-medium mt-10"
            @click="addCriterion(1)"
          >
            <span class="plus-button 2xl:h-10 2xl:w-10">
              <icon name="plus" />
            </span>
            <span class="text-base text-gray-600 ml-3 mt-1.5 flex-initial">
              Ajouter un intitulé
            </span>
          </div>
          <!-- END Button to add a intitulé -->
        </div>

        <div
          v-if="template[2]"
          id="title2"
          class="text-base mb-8 uppercase"
        >
          {{ template[2].libelle }}
        </div>

        <checkbox-indigo
          v-if="template[2]"
          name="displayCommentaire"
          libelle="Afficher le champ commentaire"
          :value="template[2].isDisplayed"
          @input="
            (newValue) => {
              template[2].isDisplayed = newValue;
            }
          "
        />
      </div>
    </div>
    <div v-else>
      <!-- Title -->
      <div class="mb-5 md:mb-15 2xl:mb-20">
        <h3>
          {{ this.infosPage.libelle_template }}
        </h3>
      </div>
      <!-- END Title -->

      <!-- BEGIN Bloc action buttons -->
      <list-buttons
        :evaluation-in-progress="evaluationInProgress"
        :is-active="infosPage.is_active"
        @preview="
          () => {
            showPreview = true;
          }
        "
        @deactivateTemplate="displayConfirmDeactivateTemplate()"
        @assignTemplate="displayAssignTemplate()"
        @activateTemplate="displayConfirmActivateTemplate()"
        :can-delete="false"
      />
      <!-- END Bloc action buttons -->

      <!-- Custom content -->
      <div class="mx-15">
        <!-- Contenu de la partie personnalisable -->
        <h3 class="text-lg text-gray-600">
          Le modèle de page {{ this.infosPage.libelle_template }} n'est pas
          modifiable.<br>
          Vous pouvez simplement
          <span v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER)">activer ou désactiver</span><span v-else>visualiser</span> le modèle de page.
        </h3>
        <div class="my-15 flex justify-center">
          <illustration name="notAllowed" />
        </div>
      </div>
      <!-- END Custom content -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import InputText from '../../components/Inputs/InputText';
import InputTextArea from '../../components/Inputs/InputTextArea';
import InputSelect from '../../components/Inputs/InputSelect';
import CheckboxIndigo from '../../components/Inputs/CheckboxIndigo.vue';
import IconComment from '../../components/Inputs/IconComment';
import InputTitle from '../../components/Inputs/InputTitle';

import ActionButton from '../../components/ActionButton';
import ListButtons from './../../components/Templates/listButtons.vue';

import Icon from '../../components/Icon';
import Illustration from '../../components/Illustration';
import Popup from '../../components/Popup';

import store from '../../store';
import ClickOutside from 'vue-click-outside';
import draggable from 'vuedraggable';

import DeactivateTemplatePopup from './../../components/Templates/DeactivateTemplatePopup';
import ActivateTemplatePopup from './../../components/Templates/ActivateTemplatePopup';

import Constants from './../../constants';
import MassTemplateAssignation from './popups/MassTemplateAssignation.vue';
import ListGrid from '../../components/AccordionTable/ListGrid.vue';
import EvalInProgress from './EvalInProgress.vue';

export default {
  components: {
    MassTemplateAssignation,
    EvalInProgress,
    ListGrid,
    InputText,
    InputTextArea,
    InputSelect,
    Icon,
    ActionButton,
    Popup,
    Illustration,
    IconComment,
    draggable,
    ListButtons,
    DeactivateTemplatePopup,
    ActivateTemplatePopup,
    InputTitle,
    CheckboxIndigo,
  },

  name: 'ReferentielMulti2',

  data() {
    return {
      confirmDeleteTemplate: -1,
      confirmDeactivateTemplate: -1,
      confirmActivateTemplate: -1,
      editName: false,
      dropDownMenu: -1,
      template: [
        { type: 'multi', libelle: 'Critères d\'évaluation', criterions: [] },
        { type: 'list', libelle: 'Intitulés des évaluations', criterions: [] },
        { type: 'choice', libelle: 'Champ commentaire', isDisplay: false },
      ],
      emptyTemplate: [
        { type: 'multi', libelle: 'Critères d\'évaluation', criterions: [] },
        { type: 'list', libelle: 'Intitulés des évaluations', criterions: [] },
        { type: 'choice', libelle: 'Champ commentaire', isDisplay: false },
      ],
      showPreview: false,
      currentField: 0,
      showList: false,
      displayValider: -1,
      templateNameToDelete: '',
      templateNameToDeactivate: '',
      isDragEnabled: true,
      massAssignation: false,
      massAssignationTemplate: {},
      constants: Constants,
    };
  },

  mounted() {
    this.initPage();
  },

  async beforeRouteUpdate(to, from, next) {
    store.commit('app/SET_LOADING', true);
    let url = to.path.split('/modeles-de-page/')[1].split('/');

    await store.dispatch('template/change_page', url).then((response) => {
      this.initPage();
      next();
    });
  },

  methods: {
    ...mapActions({
      save_datas: 'template/save_datas',
      delete_template: 'template/delete_template',
      switchState: 'template/switchState',
    }),

    ...mapMutations({
      SET_TEMPLATEVERSIONS: 'template/SET_TEMPLATEVERSIONS',
      SET_TEMPLATECONTENT: 'template/SET_TEMPLATECONTENT',
      SET_LIBELLE_TEMPLATE: 'template/SET_LIBELLE_TEMPLATE',
      SET_NAME_TEMPLATE_IN_LIST: 'template/SET_NAME_TEMPLATE_IN_LIST',
      SET_ISACTIVE: 'template/SET_ISACTIVE',
      SET_MESSAGEHEADER: 'template/SET_MESSAGEHEADER',
    }),
    displayAssignTemplate() {
      this.massAssignationTemplate = {
        id: this.infosPage.id_template,
        name: this.infosPage.libelle_template,
        page_id: this.infosPage.id_page
      };
      this.massAssignation = true;
    },
    loadEmptyForm() {
      this.template = [...this.emptyTemplate];
    },

    initTemplate() {
      if (this.templateContent.length > 0) {
        //load values in form and keep templateContent with initial values to compare when leave page without saving
        this.template = [...this.templateContent];
      }
    },

    async initPage() {
      await this.loadEmptyForm();
      await this.initTemplate();

      this.confirmDeleteTemplate = -1;
      this.confirmDeactivateTemplate = -1;
      this.confirmActivateTemplate = -1;

      store.commit('app/SET_LOADING', false);
      this.infosPage.isTemplateChanged = false;
    },

    confirm_delete_template(templateToReplace = null) {
      this.delete_template(templateToReplace), (this.confirmDeleteTemplate = 1);
    },

    displayDropdownMenu(index) {
      this.dropDownMenu = index;
    },

    forceHide() {
      if (this.dropDownMenu >= 0) {
        this.dropDownMenu = -1;
      }
    },

    addField(type) {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.template.push({
          type: type,
          libelle: 'Nom du champ',
          criterions: [],
        });
        this.dropDownMenu = false;
      }
    },

    deleteField(index) {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.template.splice(index, 1);
      }
    },

    addCriterion(index) {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        if (index === 1) {
          let loc = this.templateContent[index].criterions.length + 1;
          this.templateContent[index].criterions.unshift({
            description: 'Example description',
            libelle: 'Libelle',
            location: loc.toString(),
          });

          let pos = document.getElementById('intitule0');
          pos.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (index === 0) {
          if (this.template[index].criterions.length < 10) {
            this.template[index].criterions.push({ value: '' });
          } else {
            this.SET_MESSAGEHEADER({
              type: 'warning',
              msg: 'Vous avez atteint la limite de 10 critères maximum',
            });
            setTimeout(() => {
              this.SET_MESSAGEHEADER(null);
            }, 3000);
          }
        }
      }
    },

    deleteCriterion(typeCriterion, index) {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.template[typeCriterion].criterions.splice(index, 1);
      }
    },

    cloneCriterion(typeCriterion, index) {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        let newCriterion = {
          ...this.template[typeCriterion].criterions[index],
        };
        newCriterion.location = (
          parseInt(this.template[typeCriterion].criterions[index].location) + 1
        ).toString();
        this.template[typeCriterion].criterions.splice(index, 0, newCriterion);
      }
    },

    editCriterion(index) {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.isDragEnabled = false;
        this.displayValider = index;
      }
    },

    validEdit() {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.displayValider = -1;
        this.isDragEnabled = true;
      }
    },

    displayConfirmDeleteTemplate() {
      if (
        this.templatePageToAssignAfterDelete == null ||
        this.templatePageToAssignAfterDelete == undefined
      ) {
        this.SET_MESSAGEHEADER({
          type: 'error',
          msg: 'Vous ne pouvez pas supprimer le dernier modèle de ce type',
        });
        setTimeout(() => {
          this.SET_MESSAGEHEADER(null);
        }, 3000);
        return;
      }
      if (this.listAssignedUsersTemplate.length == 0) {
        this.confirmDeleteTemplate = 0;
      }
      if (this.listAssignedUsersTemplate.length > 0) {
        this.confirmDeleteTemplate = 2;
      }

      this.templateNameToDelete = this.infosPage.libelle_template;
    },

    displayConfirmDeactivateTemplate() {
      if (
        this.templatePageToAssignAfterDelete == null ||
        this.templatePageToAssignAfterDelete == undefined
      ) {
        this.SET_MESSAGEHEADER({
          type: 'error',
          msg: 'Vous ne pouvez pas désactiver le dernier modèle de ce type',
        });
        setTimeout(() => {
          this.SET_MESSAGEHEADER(null);
        }, 3000);
        return;
      }

      if (this.listAssignedUsersTemplate.length == 0) {
        this.confirmDeactivateTemplate = 0;
      }
      if (this.listAssignedUsersTemplate.length > 0) {
        this.confirmDeactivateTemplate = 2;
      }

      this.templateNameToDeactivate = this.infosPage.libelle_template;
    },

    displayConfirmActivateTemplate() {
      this.confirmActivateTemplate = 0;
      this.templateNameToDeactivate = this.infosPage.libelle_template;
    },

    confirm_deactivate_template(templateToReplace = null) {
      this.switchState({
        state: !this.infosPage.is_active,
        newTemplateToAssign: templateToReplace,
      });
      this.confirmDeactivateTemplate = 1;
    },

    confirm_activate_template() {
      this.switchState({
        state: !this.infosPage.is_active,
        newTemplateToAssign: null,
      });
      this.confirmActivateTemplate = 1;
    },
  },
  computed: {
    ...mapGetters({
      infosPage: 'template/infosPage',
      listPageTemplates: 'template/listPageTemplates',
      templateVersions: 'template/templateVersions',
      templateContent: 'template/templateContent',
      evaluationInProgress: 'template/evaluationInProgress',
      listAssignedUsersTemplate: 'template/listAssignedUsersTemplate',
    }),

    templatePageToAssignAfterDelete() {
      let nextPageTemplate = this.listPageTemplates.filter(
        (t) =>
          t.page_name == this.infosPage.name_page &&
          t.id != this.infosPage.id_template &&
          t.is_active == 1
      );
      return nextPageTemplate.length > 0 ? nextPageTemplate[0] : null;
    },

    dragOptions() {
      return {
        animation: 500,
        disabled:
          !this.isDragEnabled ||
          !this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER),
        ghostClass: 'bg-indigo-300',
      };
    },

    isEditable() {
      return (
        (typeof this.infosPage.editable === 'boolean' &&
          this.infosPage.editable === true) ||
        (typeof this.infosPage.editable === 'number' &&
          this.infosPage.editable === 1) ||
        (typeof this.infosPage.editable === 'string' &&
          this.infosPage.editable === '1')
      );
    },
  },

  watch: {
    template: {
      handler() {
        this.infosPage.isTemplateChanged = true;
      },
      deep: true,
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>